import moment, { type Moment } from 'moment';
import { isDayjs, type Dayjs } from 'dayjs';

/**
 * Coerce an engine-resolved date bound (Moment | Dayjs | Date | string | number)
 * into a Moment for antd v4's Moment-typed DatePicker.
 *
 * `moment(value)` cannot read a Dayjs instance and silently falls back to "now",
 * which quietly drops cross-field date bounds whenever the store holds Dayjs values
 * (e.g. edit-mode hydration via `parseToDayjs`). Convert Dayjs through its native
 * Date first so the real date survives. Returns `undefined` for empty/invalid input.
 */
export const toMoment = (value: unknown): Moment | undefined => {
    if (value == null || value === '') return undefined;
    if (moment.isMoment(value)) return value.isValid() ? value : undefined;
    if (isDayjs(value)) {
        const converted = moment((value as Dayjs).toDate());
        return converted.isValid() ? converted : undefined;
    }
    const parsed = moment(value as moment.MomentInput);
    return parsed.isValid() ? parsed : undefined;
};
